var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('manual-mapping-solution-hardware-item',{attrs:{"index":_vm.index,"name":_vm.name,"description":_vm.description,"is-mapped":false,"is-currently-mapping":_vm.isCurrentlyMapping,"disabled":_vm.disabled},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }